/**
 * A BROWSER STUB FOR `node:fs` — it exports nothing that works, ON PURPOSE.
 *
 * The marking engine (slm-tutor/drawing-check.mjs) reads its 202 drawing specs off disk in node. In a
 * browser there is no disk, so the import must resolve to something — and the honest something is a
 * module whose functions are undefined. `loadSpecs()` already guards with
 * `typeof readdirSync !== 'function'` and returns [] there, and the browser injects the specs it
 * fetched instead, via `useSpecs()`.
 *
 * These are deliberately NOT throwing stubs. A throw would turn "there is no filesystem here" into a
 * crash, when the engine already has a correct answer for that case. And they are deliberately not
 * fake implementations either: nothing here pretends to read a file.
 */
export const readFileSync = undefined;
export const readdirSync = undefined;
export const existsSync = undefined;
export default { readFileSync, readdirSync, existsSync };
